import { buildStyledXlsx, propertyLabel, relationName } from "./helpers";
import type { AssetNoteRow, AssetRow, PropertyRow } from "./types";

export function buildCategoryNotesXlsx(
  assets: AssetRow[],
  assetNotes: AssetNoteRow[],
  propertyMap: Map<string, PropertyRow>,
): ArrayBuffer {
  const notesByAssetId = new Map<string, AssetNoteRow[]>();
  for (const note of assetNotes) {
    const notes = notesByAssetId.get(note.asset_id) ?? [];
    notes.push(note);
    notesByAssetId.set(note.asset_id, notes);
  }

  const rows: string[][] = [[
    "Property",
    "Store #",
    "Category",
    "Asset",
    "Note Source",
    "Note",
    "Created At",
  ]];

  for (const asset of assets) {
    const property = propertyMap.get(asset.property_id);
    const category = relationName(asset.asset_categories) || "Uncategorized";
    const assetLabel = asset.name ?? asset.id;

    if (asset.notes?.trim()) {
      rows.push([
        propertyLabel(property),
        property?.store_number ?? "",
        category,
        assetLabel,
        "Asset notes field",
        asset.notes,
        "",
      ]);
    }

    for (const note of notesByAssetId.get(asset.id) ?? []) {
      rows.push([
        propertyLabel(property),
        property?.store_number ?? "",
        category,
        assetLabel,
        "Asset note",
        note.note_text,
        note.created_at,
      ]);
    }
  }

  if (rows.length === 1) {
    rows.push(["", "", "", "", "", "No category notes found", ""]);
  }

  return buildStyledXlsx(rows, "Category Notes", [24, 12, 24, 30, 18, 64, 24]);
}
